import ContentConfig from '../config/ContentConfig';
import logger from '../log';
import getUrlPrefix from './getUrlPrefix';
import { ElevenAgentData } from './interfaces';
import { setElevenData } from './store11AgentInfo';

const log = logger.getLogger(__filename);

export default async function (
  config: ContentConfig,
  controller: AbortController
): Promise<ElevenAgentData | undefined> {
  if (config.agent.disabled || !config.agent.port) {
    log.debug('11 Agent disabled or missing port', config.agent);
    return Promise.resolve(undefined);
  }
  const url = `${getUrlPrefix(config)}:${config.agent.port}/config`;

  const options = { signal: controller.signal };
  return fetch(url, options)
    .then(async (res: Response) => {
      if (!res.ok) {
        throw new Error(`bad response ${res.status} "${res.statusText}"`);
      }
      const eleven = await res.json();
      setElevenData(eleven);
      return eleven;
    })
    .catch(e => {
      log.debug(`No 11 agent found '${e.message}'`);
      return undefined;
    });
}
